import { Spinner, Button, Box } from '@chakra-ui/react';
import { ResyncIcon } from '@assets/icons/index';
import { TextBold } from '@components/typography';
import { useGlobalFilter } from '@pages/SelloutMonitoring/hooks/state/globalFilter';
import useGetResyncData from '@domain/selloutMonitoring/useGetResyncData';
import useGetSelloutMonitoring from '@domain/selloutMonitoring/useSelloutMonitoring';
import { useFilter } from '@pages/SelloutMonitoring/hooks/state/filters';
import { useConfirmModal } from '@store/useConfirmModal';
import { EmptyStateGrayscale2Image, ProcessingState } from '@assets/images';
import { isEmpty } from 'lodash';

const Resync = () => {
    const confirmModal = useConfirmModal();
    const globalFilter = useGlobalFilter();
    const localFilter = useFilter();

    const { data } = useGetSelloutMonitoring({
        ...globalFilter,
        ...localFilter,
    });

    const { mutate, isPending } = useGetResyncData(globalFilter);

    const customerName = globalFilter?.customer?.name ?? 'Customer Name';
    const isMissingFilter = !globalFilter?.group && !globalFilter?.customer;
    const isResyncDisabled = !isEmpty(globalFilter?.customer) && data?.is_resync === false;

    const openModal = (config) => confirmModal.set({ isOpen: true, ...config });

    const handleResync = () => {
        if (isMissingFilter) {
            return openModal({
                title: 'Lengkapi Data Terlebih Dulu',
                desc: 'Pilih dan lengkapi untuk menampilkan data sellout yang diinginkan.',
                isShowBtnNo: false,
                btnLabelYes: 'Mengerti',
                isDanger: false,
                ConfirmationStateImage: ProcessingState,
            });
        }

        if (isResyncDisabled) {
            return openModal({
                title: 'Data Tidak Dapat di Resync',
                desc: (
                    <>
                        Pengaturan fitur resync untuk{' '}
                        <Box as="span" color="paragon.500" fontWeight="bold">
                            {customerName}
                        </Box>{' '}
                        belum diaktifkan, masuk ke store config dan pilih POS Sync.
                    </>
                ),
                isShowBtnNo: false,
                isDanger: false,
                btnLabelYes: 'Mengerti',
                ConfirmationStateImage: EmptyStateGrayscale2Image,
            });
        }

        mutate();
    };

    return (
        <Button
            onClick={handleResync}
            disabled={isPending}
            variant="unstyled"
            minW="140px"
            border="1px solid #D6D6D6"
            display="flex"
            alignItems="center"
            gap="8px"
        >
            {isPending ? (
                <Spinner />
            ) : (
                <>
                    <ResyncIcon />
                    <TextBold>Resync Data</TextBold>
                </>
            )}
        </Button>
    );
};

export default Resync;
